import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  RiMailFill,
  RiLock2Fill,
  RiArrowRightLine,
  RiShieldCheckLine,
  RiUser3Fill,
  RiPhoneFill,
} from "react-icons/ri";
import { Formik } from "formik";
import * as Yup from "yup";
import { Modal, MyInput } from "../../ui";
import Popup from "../../utils/Popup/Popup";
import LoginModal from "../LoginModal/LoginModal";
import Axios from "../../Axios"
import "./signupModal.scss";

const logo = require("../../assets/logo-with-bottom-name.png");
const man = require("../../assets/businessman.png");

const schemas = Yup.object().shape({
  firstname: Yup.string().required("Хоосон байна!"),
  lastname: Yup.string().required("Хоосон байна!"),
  phone_number: Yup.string()
    .matches(/^[0-9]*$/, "Зөвхөн тоо бичнэ үү!")
    .min(8, "Урт багадаа 8 байх ёстой!")
    .max(8, "8-аас их байж болохгүй!")
    .required("Хоосон байна!"),
  email: Yup.string()
    .email("Зөв форматаар бичнэ үү!")
    .matches(/[a-z0-9]+@[a-z]+\.[a-z]{2,3}/, "Зөв форматаар бичнэ үү!")
    .required("Хоосон байна!"),
  citizenship: Yup.string().required("Хоосон байна!"),
  password: Yup.string()
    .min(8, "Хамгийн багадаа 8 тэмдэгт байх ёстой!")
    .required("Хоосон байна!"),
  repassword: Yup.string()
    .oneOf([Yup.ref("password")], "Таарахгүй байна!")
    .required("Хоосон байна!"),
});

const SignupModal = ({ visible, setVisible }) => {
  const [visibleLogin, setVisibleLogin] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [popupText, setPopupText] = useState("");
  const [visiblePopup, setVisiblePopup] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [signupEmail, setSignupEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(60);

  const signupHandler = (values, resetForm) => {
    Axios.post("/auth/signup", values)
      .then((res) => {
        if (res?.data) {
          setSignupEmail(values.email);
          setShowOTP(true);
          setVisible(false);
        }
      })
      .catch((err) => {
        console.log("ERROR:", err.response);

        setPopupType("error");
        setPopupText(
          err?.response?.data?.message || "Алдаа гарлаа"
        );
        setVisiblePopup(true);
      });
  };
  const verifyOTP = () => {
    Axios.post("/auth/verify-email", {
      email: signupEmail,
      code: otp,
    })
      .then(() => {
        setPopupType("success");
        setPopupText("Амжилттай баталгаажлаа");
        setVisiblePopup(true);

        setShowOTP(false);
        setVisibleLogin(true);
      })
      .catch(() => {
        setPopupType("error");
        setPopupText("Код буруу байна");
        setVisiblePopup(true);
      });
  };
  const popupOnOK = () => {
    setVisiblePopup(false);

    if (!String(popupType).includes("error")) {
      setVisibleLogin(true);
    }
  };
  const resendOTP = () => {
    Axios.post("/auth/resend-otp", { email: signupEmail })
      .then(() => {
        setTimer(60);
      });
  };
  useEffect(() => {
    if (!showOTP) return;

    setTimer(60);

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [showOTP]);
  return (
    <>
      <LoginModal visible={visibleLogin} setVisible={setVisibleLogin} />

      <Popup
        messageType={popupType}
        messageText={popupText}
        visible={visiblePopup}
        onOk={popupOnOK}
      />
      {showOTP && (
        <Modal visible={showOTP} onCancel={() => setShowOTP(false)}>
          <div style={{ padding: 30, textAlign: "center" }}>
            
            <h3>Код оруулна уу</h3>
            <p>{signupEmail} рүү код илгээгдсэн</p>
            <p style={{ textAlign: "center", fontSize: 13, color: "#666", marginTop: 8 }}>
              Хэрэв код ирэхгүй байвал spam-аа шалгаарай.
            </p>
            <input
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              maxLength={6}
              style={{
                width: "100%",
                height: "50px",
                fontSize: "24px",
                textAlign: "center",
                letterSpacing: "10px",
                borderRadius: "10px",
                border: "1px solid #ccc",
                marginBottom: "20px",
              }}
            />

            <button
              onClick={verifyOTP}
              className="signupModal__submit"
            >
              Баталгаажуулах
            </button>

            {timer > 0 ? (
              <p style={{ marginTop: 10 }}>
                Дахин илгээх ({timer}s)
              </p>
            ) : (
              <button
                onClick={resendOTP}
                style={{
                  marginTop: 10,
                  background: "none",
                  border: "none",
                  color: "#250a8d",
                  cursor: "pointer",
                }}
              >
                Код дахин илгээх
              </button>
            )}

          </div>
        </Modal>
      )}
      <Modal visible={visible} onCancel={setVisible}>
        <div className="signupModal">
          <div className="signupModal__left">
            <div className="signupModal__brand">
              <img className="signupModal__brand-logo" src={logo} alt="logo" />

              <div className="signupModal__brand-copy">
                <span className="signupModal__badge">
                  <RiShieldCheckLine />
                  Шинэ бүртгэл
                </span>
              </div>
            </div>

            <div className="signupModal__illustrationWrap">
              <div className="signupModal__glow" />
              <img className="signupModal__man" src={man} alt="illustration" />
            </div>
          </div>

          <div className="signupModal__right">
            <div className="signupModal__panel">
              <div className="signupModal__heading">
                <h3>Бүртгүүлэх</h3>
              </div>

              <Formik
                initialValues={{
                  firstname: "",
                  lastname: "",
                  phone_number: "",
                  email: "",
                  citizenship: "",
                  password: "",
                  repassword: "",
                }}
                validationSchema={schemas}
                onSubmit={(vals, { resetForm }) =>
                  signupHandler(vals, resetForm)
                }
              >
                {({
                  values,
                  errors,
                  touched,
                  setFieldTouched,
                  setFieldValue,
                  handleChange,
                  handleSubmit,
                }) => (
                  <form className="signupModal__form" onSubmit={handleSubmit}>
                    <div className="signupModal__row">
                      <div className="signupModal__field">
                        <label>Овог</label>
                        <MyInput
                          icon={<RiUser3Fill />}
                          placeholder="Овог"
                          name="lastname"
                          value={values.lastname}
                          onChange={(e) =>
                            setFieldValue("lastname", e.target.value)
                          }
                          onBlur={() => setFieldTouched("lastname")}
                          touched={touched.lastname}
                          errorText={errors.lastname}
                        />
                      </div>

                      <div className="signupModal__field">
                        <label>Нэр</label>
                        <MyInput
                          icon={<RiUser3Fill />}
                          placeholder="Нэр"
                          name="firstname"
                          value={values.firstname}
                          onChange={(e) =>
                            setFieldValue("firstname", e.target.value)
                          }
                          onBlur={() => setFieldTouched("firstname")}
                          touched={touched.firstname}
                          errorText={errors.firstname}
                        />
                      </div>
                    </div>
                    <div className="signupModal__row">
                      <div className="signupModal__field">
                        <label>Утасны дугаар</label>
                        <MyInput
                          icon={<RiPhoneFill />}
                          placeholder="99112233"
                          name="phone_number"
                          value={values.phone_number}
                          onChange={(e) =>
                            setFieldValue("phone_number", e.target.value)
                          }
                          onBlur={() => setFieldTouched("phone_number")}
                          touched={touched.phone_number}
                          errorText={errors.phone_number}
                        />
                      </div>
                      <div className="signupModal__field">
                        <label>И-Мэйл</label>
                        <MyInput
                          icon={<RiMailFill />}
                          placeholder="example@email.com"
                          name="email"
                          value={values.email}
                          onChange={(e) =>
                            setFieldValue("email", e.target.value.trim().toLowerCase())
                          }
                          onBlur={() => setFieldTouched("email")}
                          touched={touched.email}
                          errorText={errors.email}
                        />
                      </div>
                    </div>

                    <div className="signupModal__field">
                      <label>Иргэншил</label>
                      <select
                        name="citizenship"
                        value={values.citizenship}
                        onChange={handleChange}
                        onBlur={() => setFieldTouched("citizenship")}
                        className={`signupModal__select ${
                          touched.citizenship && errors.citizenship
                            ? "error"
                            : ""
                        }`}
                      >
                        <option value="">-- сонгох --</option>
                        <option value="Монгол">Монгол</option>
                        <option value="Бусад">Бусад</option>
                      </select>
                      {touched.citizenship && errors.citizenship ? (
                        <span className="signupModal__error">
                          {errors.citizenship}
                        </span>
                      ) : null}
                    </div>

                    <div className="signupModal__row">
                      <div className="signupModal__field">
                        <label>Нууц үг</label>
                        <MyInput
                          icon={<RiLock2Fill />}
                          placeholder="••••••••"
                          name="password"
                          type="password"
                          value={values.password}
                          onChange={handleChange}
                          onBlur={() => setFieldTouched("password")}
                          touched={touched.password}
                          errorText={errors.password}
                        />
                      </div>

                      <div className="signupModal__field">
                        <label>Нууц үг давтах</label>
                        <MyInput
                          icon={<RiLock2Fill />}
                          placeholder="••••••••"
                          name="repassword"
                          type="password"
                          value={values.repassword}
                          onChange={handleChange}
                          onBlur={() => setFieldTouched("repassword")}
                          touched={touched.repassword}
                          errorText={errors.repassword}
                        />
                      </div>
                    </div>

                    <button type="submit" className="signupModal__submit">
                      <span>Бүртгүүлэх</span>
                      <RiArrowRightLine />
                    </button>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SignupModal;
